/**
 * Login contra Supabase Auth.
 *
 * Solo email + password. Sin registro y sin "olvide mi contrasena": los
 * usuarios de un panel interno se dan de alta desde el panel de Supabase, y
 * agregar un flujo de self-service aca seria abrir una puerta que nadie pidio.
 *
 * El submit no hace nada mas que llamar a Supabase: el resto (guardar sesion,
 * refrescar token, avisarle a la app) lo maneja `AuthProvider` escuchando
 * `onAuthStateChange`. Navegar a mano despues del login seria duplicar esa
 * maquinaria y desincronizarla.
 */

import { useState, type FormEvent } from "react";

import { useAuth } from "./AuthProvider";

export function LoginPage() {
  const { signInWithPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await signInWithPassword(email, password);
    } catch (cause) {
      // El mensaje de Supabase ya es generico ("Invalid login credentials"):
      // no distingue usuario inexistente de password incorrecta, que es lo
      // correcto para no enumerar cuentas.
      setError(cause instanceof Error ? cause.message : "No se pudo iniciar sesion.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login">
      <form className="login__form" onSubmit={(event) => void handleSubmit(event)}>
        <h1>Barrio Chino</h1>
        <p className="login__lead">Panel interno</p>

        <label>
          <span>Email</span>
          <input
            type="email"
            name="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>

        <label>
          <span>Contrasena</span>
          <input
            type="password"
            name="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>

        {error ? (
          <p className="login__error" role="alert">
            {error}
          </p>
        ) : null}

        <button type="submit" disabled={submitting}>
          {submitting ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </main>
  );
}
